import type { PaginationInfo } from '@/types/pagination';
import type { AddReviewFormData, ReviewsPaginationInfo } from './types';

export const defaultFormData: AddReviewFormData = {
  attorneyId: '',
  attorneyName: '',
  reviewerName: '',
  reviewerEmail: '',
  title: '',
  description: '',
  reviewSummary: '',
  rating: null,
};

export function extractErrorMessage(error: unknown, fallback: string): string {
  const data = (error as { response?: { data?: { error?: unknown } } })?.response?.data?.error;

  if (typeof data === 'string' && data.length > 0) return data;
  if (Array.isArray(data)) return data.join(', ') || fallback;
  if (data && typeof data === 'object') {
    return Object.values(data).flat().join(', ') || fallback;
  }

  return fallback;
}

export function formatReceivedDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function normalizePaginationInfo(
  pagination: ReviewsPaginationInfo | undefined,
  defaultPerPage: number,
): PaginationInfo {
  if (!pagination) {
    return {
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      perPage: defaultPerPage,
    };
  }

  if ('currentPage' in pagination) return pagination;

  return {
    currentPage: pagination.current_page,
    totalPages: pagination.total_pages,
    totalCount: pagination.total_count,
    perPage: pagination.per_page,
  };
}

export function buildReviewRequestPayload({
  attorneyId,
  attorneyName,
  reviewerName,
  reviewerEmail,
  title,
  description,
  reviewSummary,
  rating,
  showStarRatingOnWebsite,
}: AddReviewFormData & {
  rating?: number | null;
  showStarRatingOnWebsite?: boolean;
}) {
  return {
    review: {
      attorneyId,
      attorneyName,
      reviewerName,
      reviewerEmail,
      title,
      description,
      reviewSummary,
      rating,
      showStarRatingOnWebsite,
    },
  };
}
